import Logo from "./Logo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { id: "about", label: "About" },
  { id: "operations", label: "Operations" },
  { id: "careers", label: "Careers" },
  { id: "branches", label: "Branches" },
  { id: "leadership", label: "Leadership" },
  { id: "contact", label: "Contact" },
];

export const Footer = () => (
  <footer className="border-t border-white/5 bg-ink py-14">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">
        <div className="max-w-sm">
          <Logo />
          <p className="mt-5 text-sm leading-relaxed text-slate-400">
            Manufacturing • Distribution • Online — an ISO 9001:2015 certified
            business group operating from Alappuzha, across Kerala.
          </p>
          <div className="mt-5 flex gap-2">
            <span className="rounded-full border border-white/15 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-300">
              ISO 9001:2015
            </span>
            <span className="rounded-full border border-white/15 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-300">
              FSSAI
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">Navigate</p>
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`footer-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="w-fit text-sm text-slate-400 transition-colors hover:text-brand-bright"
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex flex-col gap-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">Head Office</p>
          <p className="text-sm leading-relaxed text-slate-400">
            Kainakari Building, 2nd Floor<br />
            (above ESAF Bank), Near Powerhouse<br />
            Alappuzha, Kerala 688007, India<br />
            +91 79074 40408 • +91 96050 96999<br />
            techworldgroup22@gmail.com
          </p>
        </div>
      </div>

      <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/5 pt-8 sm:flex-row">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
          © {new Date().getFullYear()} Techworld Business Group. All rights reserved.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href="/admin"
            data-testid="footer-hr-login-link"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 transition-colors hover:text-brand-bright"
          >
            HR Login
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
